import React, { useCallback, lazy, Suspense } from "react";
import "./productaction.css";
import BlueButton from "./BlueButton";

const ProductCard = lazy(() => import("./product-card-animation/ProductCard"));
const TextAnimation = lazy(() =>
  import("./productViewCarosul/ProductViewCarosul")
);

function ProductAction() {
  const s3url = process.env.REACT_APP_S3_URL;

  const handleScroll = useCallback((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, []);

  return (
    <div className="product-action-container">
      <div className="product-action-heading">
        Our products{" "}
        <span style={{ color: "#6D2FEC", fontFamily: "nohemi-bold" }}>
          in action
        </span>
      </div>
      <div
        id="product-click"
        className="flexprop"
        style={{
          flexDirection: "row",
          gap: "7.5rem",
          flexWrap: "wrap",
        }}
      >
        <div style={{ marginTop: "2rem" }}>
          <Suspense fallback={<div>Loading Product...</div>}>
            <ProductCard />
          </Suspense>
        </div>
        <GroupComponent
          mainHeading={"Make decisions easily with "}
          highlightText={" Real-time reporting"}
          subHeading={
            "Get real-time info easily—make smart decisions, improve customer experience, and stay ahead of the competition without any hassle."
          }
          buttonText={"Book a Demo"}
          buttonHandler={() => handleScroll("book-a-demo")}
        />
      </div>
      <div
        className="flexprop"
        style={{
          flexDirection: "row-reverse",
          gap: "6rem",
          flexWrap: "wrap",
        }}
      >
        <img
          // src={`${s3url}/product_action_response_view.svg`}
          src="/images/image.png"
          alt=""
          className="product-action-card"
          loading="lazy"
          decoding="async"
        />
        <GroupComponent
          mainHeading={"Enter Input & "}
          highlightText={" Get Verified Data"}
          subHeading={
            "Ensure data accuracy with BeFisc. Simply input data and get verified results in seconds."
          }
          buttonText={"Book a Demo"}
          buttonHandler={() => handleScroll("book-a-demo")}
        />
      </div>
      {/* <div className="product-action-carosul-part">
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <div className="carosul-main-heading">A view for everyone</div>
          <div className="carosul-sub-heading">
            See data the way you prefer.
          </div>
        </div>
        <div className="carosul-btn">
          <BlueButton
            text={"Book a Demo"}
            onClick={() => handleScroll("book-a-demo")}
          />
        </div>
        <Suspense fallback={<div>Loading Carousel...</div>}>
          <TextAnimation />
        </Suspense>
      </div> */}
    </div>
  );
}

export default React.memo(ProductAction);

const GroupComponent = React.memo(
  ({ mainHeading, highlightText, subHeading, buttonText, buttonHandler }) => {
    return (
      <div className="group-container">
        <div className="group-main-heading">
          {mainHeading}
          <span style={{ color: "#6D2FEC" }}>{highlightText}</span>
        </div>
        <div className="group-sub-heading">{subHeading}</div>
        <div className="group-button-container">
          <BlueButton
            text={buttonText}
            styles={{ width: "100%" }}
            onClick={buttonHandler}
          />
        </div>
      </div>
    );
  }
);
